"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isContinentProperty = exports.continentPropertyDefinition = void 0;
exports.continentPropertyDefinition = {
    view: { label: 'Continent' },
    constraints: [
        {
            name: 'options',
            argument: [
                'Europe',
                'North America',
                'South America',
                'Asia',
                'Australia',
                'Africa',
                'Antarctica',
            ],
        },
    ],
    type: 'select',
    multiple: false,
    name: 'continent',
};
const isContinentProperty = (prop) => {
    return prop.name === exports.continentPropertyDefinition.name;
};
exports.isContinentProperty = isContinentProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGluZW50LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY29udGluZW50LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMkJBQTJCLEdBQUc7SUFDekMsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFdBQVcsRUFBRTtJQUM1QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxTQUFTO1lBQ2YsUUFBUSxFQUFFO2dCQUNSLFFBQVE7Z0JBQ1IsZUFBZTtnQkFDZixlQUFlO2dCQUNmLE1BQU07Z0JBQ04sV0FBVztnQkFDWCxRQUFRO2dCQUNSLFlBQVk7YUFDYjtTQUNGO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsUUFBUTtJQUNkLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLFdBQVc7Q0FDYyxDQUFBO0FBSTFCLE1BQU0sbUJBQW1CLEdBQUcsQ0FBQyxJQUFrQixFQUE2QixFQUFFO0lBQ25GLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxtQ0FBMkIsQ0FBQyxJQUFJLENBQUE7QUFDdkQsQ0FBQyxDQUFBO0FBRlksUUFBQSxtQkFBbUIsdUJBRS9CIn0=